import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import MText from "../../components/pos/MText";
import { useEffect, useState } from "react";
import { Typography, Grid, InputAdornment, IconButton } from "@mui/material";
import { PricingUtils } from "../../utils/PricingUtils";
import PText from "../../components/pos/PText";
import { green, grey, orange, purple } from "@mui/material/colors";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import PDigitPanel from "../../components/pos/PDigitPanel";
import ClearIcon from "@mui/icons-material/Clear";
const desktopTheme = createTheme({
  status: {
    danger: orange[500],
  },
  overrides: {
    MuiInputBase: {
      input: {
        fontSize: "1.9rem",
        fontWeight: "bold",
        padding: 1,
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: 10,
      },
    },
  },
});

export default function MOpenQtyPrice(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;
  const [mode, setMode] = useState("");

  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [qtyError, setQtyError] = useState("");
  const [priceError, setPriceError] = useState("");
  const [amount, setAmount] = useState("");
  const [enableOKButton, setEnableOKButton] = useState(false);
  const [currentFocus, setCurrentFocus] = useState("");

  const [title, setTitle] = useState("");

  useEffect(() => {
    if (qty.length > 0) {
      setQtyError("");
    }
  }, [qty]);
  useEffect(() => {
    if (price.length > 0) {
      setPriceError("");
    }
  }, [price]);

  useEffect(() => {
    console.log(props.productBean);

    let result = PricingUtils.derivePrice(
      props.context.store.currencyDecimal,
      props.pricingBean.cost,
      props.pricingBean.price,
      props.productBean.includeTaxInPrice,
      props.productBean.taxBean.rate,
      props.productBean.includeDiscountInPrice,
      0,
      null,
      props.productBean.isDiscounted,
      1,
      false
    );

    //setPrice(result.netAmount);

    if (props.productBean.isOpenPrice && props.productBean.isOpenQty) {
      setMode("open_price_qty");
      setCurrentFocus("qty");
      setTitle(translate("Quantity & Price"));
    } else if (props.productBean.isOpenPrice) {
      setMode("open_price");
      setCurrentFocus("price");

      setTitle(translate("Price"));
      setEnableOKButton(true);
    } else if (props.productBean.isOpenQty) {
      setMode("open_qty");
      setCurrentFocus("qty");
      setTitle(translate("Quantity"));
    }
  }, [props.productBean, props.pricingBean]);

  useEffect(() => {
    if (!amount || amount === "" || isNaN(amount)) {
      setEnableOKButton(false);
    } else {
      setEnableOKButton(true);
    }
  }, [amount]);

  useEffect(() => {
    if (mode === "open_price") {
      if (!price || price === "" || isNaN(price)) {
        setEnableOKButton(false);
      } else {
        setEnableOKButton(true);
      }
    }
  }, [price]);

  function onChangePrice(newPrice) {
    setPrice(newPrice);
    if (qty === "" || parseFloat(qty) <= 0) {
      return false;
    }
    setAmount(
      PricingUtils.formattedNumber(
        parseFloat(qty) * parseFloat(newPrice),
        props.context.store.currencyDecimal
      )
    );
  }

  function onChangeQty(newQty) {
    setQty(newQty);
    if (price === "" || parseFloat(price) <= 0) {
      return false;
    }
    let result = PricingUtils.derivePrice(
      props.context.store.currencyDecimal,
      props.pricingBean.cost,
      price,
      true,
      props.productBean.taxBean.rate,
      true,
      0,
      null,
      false,
      parseFloat(newQty),
      false
    );
    setAmount(result.netAmount);
  }

  function onChangeAmount(newAmount) {
    setAmount(newAmount);

    let result = PricingUtils.derivePrice(
      props.context.store.currencyDecimal,
      props.pricingBean.cost,
      price,
      true,
      props.productBean.taxBean.rate,
      true,
      0,
      null,
      false,
      1,
      false
    );

    let newQty = parseFloat(newAmount) / result.netAmount;

    setQty(PricingUtils.formattedNumber(newQty, 4));
  }

  let mobileContent = (
    <Grid container>
      {props.productBean.isOpenPrice && (
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <MText
            //label={translate("Price")}
            value={price}
            type={"number"}
            onChange={(e) => {
              onChangePrice(e.target.value);
            }}
          ></MText>
        </Grid>
      )}
      {props.productBean.isOpenQty && (
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <MText
            label={translate("Quantity")}
            value={qty}
            type="number"
            onChange={(e) => {
              onChangeQty(e.target.value);
            }}
          ></MText>
        </Grid>
      )}

      {props.productBean.isOpenQty && (
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <MText
            label={translate("Amount")}
            value={amount}
            readOnly={mode === "open_qty"}
            type="number"
            onChange={(e) => {
              onChangeAmount(e.target.value);
            }}
          ></MText>
        </Grid>
      )}
    </Grid>
  );

  function onKeyPressed(key) {
    console.log("currentFocus", currentFocus);
    if ("Backspace" === key) {
      if (currentFocus === "price") {
        if (price.length > 0) {
          setPrice(getSubStr(price));
        }
      }
      if (currentFocus === "qty") {
        if (qty.length > 0) {
          setQty(getSubStr(qty));
        }
      }
    } else {
      if (currentFocus === "price") {
        if ("." === key) {
          if (price.includes(".")) {
            return;
          }
        }
        setPrice(price + key);
      }
      if (currentFocus === "qty") {
        if ("." === key) {
          if (qty.includes(".")) {
            return;
          }
        }
        setQty(qty + key);
      }
    }
  }

  function getSubStr(str) {
    let s = str.substring(0, str.length - 1);
    if (s.endsWith(".")) {
      s = s.substring(0, s.length - 1);
    }
    return s;
  }
  const desktopContent = (
    <ThemeProvider theme={desktopTheme}>
      <Grid container>
        {props.productBean.isOpenPrice && (
          <Grid item xs={12} sx={{ marginTop: "10px" }}>
            <PText
              label={translate("Price")}
              value={price}
              error={priceError}
              autoFocus={true}
              onChange={(e) => {
                onChangePrice(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      style={{ color: "red" }}
                      onClick={() => {
                        setPrice("");
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onFocus={(event) => {
                setCurrentFocus("price");
              }}
              readOnly={true}
            ></PText>
          </Grid>
        )}
        {props.productBean.isOpenQty && (
          <Grid item xs={12} sx={{ marginTop: "10px" }}>
            <PText
              label={translate("Quantity")}
              value={qty}
              error={qtyError}
              autoFocus={true}
              onChange={(e) => {
                onChangeQty(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      style={{ color: "red" }}
                      onClick={() => {
                        setQty("");
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onFocus={(event) => {
                setCurrentFocus("qty");
              }}
              readOnly={true}
            ></PText>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12}>
        <PDigitPanel onKeyPressed={onKeyPressed} />
      </Grid>
    </ThemeProvider>
  );
  function validate() {
    let isValidated = true;
    if (mode === "open_price_qty") {
      if (qty === "") {
        setQtyError("Quantity Is Required");
        isValidated = false;
      }
      if (price === "") {
        setPriceError("Price Is Required");
        isValidated = false;
      }
    } else if (mode === "open_price") {
      if (price === "") {
        setPriceError("Price Is Required");
        isValidated = false;
      }
    }
    if (mode === "open_qty") {
      if (qty === "") {
        setQtyError("Quantity Is Required");
        isValidated = false;
      }
    }
    return isValidated;
  }
  return (
    <MScreen
      maxWidth="xs"
      title={title}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setCurrentScreen("sale")}
      rightAction={translate("OK")}
      onRightAction={() => {
        if (validate()) {
          if (mode === "open_price_qty") {
            props.onChangeQtyAndPrice(qty, price);
          } else if (mode === "open_price") {
            props.onChangePrice(price);
          }
          if (mode === "open_qty") {
            props.onChangeQtyAndPrice(qty, price);
          }
        }
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={
        props.context.appMode === "desktop-pos" ? true : enableOKButton
      }
      onLogOut={props.onLogOut}
      dialogMode={true}
      position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
      content={
        props.context.appMode === "desktop-pos" ? desktopContent : mobileContent
      }
    ></MScreen>
  );
}
